export const validateEmail = (email) => {
  return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};

export const validatePhone = (phone) => {
  // Updated regex to support international numbers with flexible formatting
  // This pattern allows for:
  // - An optional plus sign at the beginning
  // - Between 6-17 digits total (not counting formatting characters)
  // - Flexible formatting with spaces, dashes, dots, and parentheses
  
  // First, strip all formatting characters to count just the digits
  const digitsOnly = phone.replace(/[^\d+]/g, '');
  
  // Handle the plus sign for counting digits
  const digitCount = digitsOnly.startsWith('+') 
    ? digitsOnly.length - 1 // Don't count the plus sign
    : digitsOnly.length;
  
  // Check if we have a reasonable number of digits (6-17)
  // and that the string only contains valid phone characters
  return digitCount >= 6 && 
         digitCount <= 17 &&
         /^[+]?\d+$/.test(digitsOnly) &&
         /^[+]?[\d\s\-\(\)\.]+$/.test(phone);
};
